module.exports = __webpack_public_path__ + "static/media/liked.1db8de02.svg";